const WEBSITE_BASE_URL = 'https://cohaven.eu';


export const ExternalUrls = {
    TERMS_OF_SERVICE: `${WEBSITE_BASE_URL}/terms`,
    PRIVACY_POLICY: `${WEBSITE_BASE_URL}/privacy`,
    SUPPORT_EMAIL: 'hello@cohaven.eu',
} as const;

/**
 * Type for feature flag keys
 */
export type ExternalUrlKey = typeof ExternalUrls[keyof typeof ExternalUrls];